<template>
  <div>
    <div style="background-color: #323232; height: 78px">
      <v-row>
        <v-col cols="2" style="padding-bottom: 0; margin-top: 2px">
          <v-avatar size="54px" @click="goBack()">
            <v-icon style="color: white">mdi-chevron-left</v-icon>
          </v-avatar>
        </v-col>
        <v-col
          cols="8"
          style="display: flex; width: 100%; margin-top: 7px; heighy: 78px"
        >
          <p style="color: white">สาขาของเรา</p>
        </v-col>
        <v-col cols="2"> </v-col>
      </v-row>
    </div>
    <v-tabs v-model="tab" background-color="#FFFFFF" height="40" fixed-tabs>
      <v-tabs-slider color="red" ></v-tabs-slider>
      <v-tab style="color: black" href='#tab-1'>สาขาของเรา</v-tab>
      <!-- <v-tab style="color: black" href='#tab-2'>แผนผังของสาขา</v-tab> -->
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        value='tab-1'
      >
        <v-card flat style="height: 80vh;overflow-y:scroll;">
          <v-img :src="shop[0].pictureUrl" height="239">
        </v-img>
          <v-card-text>
            <v-container class="pa-5">
              <div v-for="(item,i) in shop" :key="i">
                <div style="font-weight: 800;font-size: 15px;line-height: 24px;color: #323232;margin-bottom:10px;" class="bold">{{item.name}}</div>
                <div style="margin-bottom:15px;">
                  <v-icon size="20px" color="#9D9D9D">
                      mdi-alarm
                  </v-icon> 08.00-17.00 น.
                </div>
                <div style="margin-bottom:15px;">
                  <v-icon size="20px" color="#9D9D9D">
                      mdi-phone
                  </v-icon> {{item.contactTel}}
                </div>
                <div style="margin-bottom:15px;">
                  <v-icon size="20px" color="#9D9D9D">
                      mdi-map-marker
                  </v-icon> {{item.Address}}
                </div>
                <div style="display: flex;justify-content:space-between;" @click="toggle()">
                  <div style="padding-top: 5px;padding-left: 20px;font-weight: 800;font-size: 15px;line-height: 24px;color: #323232;" class="bold">
                    สาขาทั้งหมดของเรา
                  </div>
                  <v-icon  v-if="isShow" style="padding-right: 30px;" size="30px">
                      mdi-menu-up-outline
                  </v-icon>
                   <v-icon v-if="isShow === false" style="padding-right: 30px;" size="30px">
                      mdi-menu-down-outline
                  </v-icon>
                </div>
                <v-divider style="margin-top: 5px;"></v-divider>
              </div>
              <!-- <transition name="slide-down"> -->
              <div v-if="isShow" :class="(isShow === true) ? 'animation' : 'test'">
                <div v-for="(item,i) in items2" :key="i">
                  <p style="font-weight: 800;font-size: 15px;line-height: 24px;color: #323232;margin-bottom:10px;" class="bold">{{shopname + ` (${item.masBranchName})`}}</p>
                <div style="margin-bottom:15px;">
                  <v-icon size="20px" color="#9D9D9D">
                      mdi-alarm
                  </v-icon> {{item.timeOC}}
                </div>
                <div style="margin-bottom:15px;">
                  <v-icon size="20px" color="#9D9D9D">
                      mdi-phone
                  </v-icon> {{item.tel}}
                </div>
                <div style="margin-bottom:15px;">
                  <v-icon size="20px" color="#9D9D9D">
                      mdi-map-marker
                  </v-icon>
                  <a :href="item.map">แผนที่</a>
                </div>
                <v-divider></v-divider>
                </div>
              </div>
              <!-- </transition> -->
            </v-container>
          </v-card-text>
        </v-card>
      </v-tab-item>
       <v-tab-item
        value='tab-2'
      >
        <v-card flat style="height: 80vh;overflow-y:scroll;">
            <v-card-text>
            <v-container class="pa-6">
              <h4>สาขาของเรา</h4>
              <v-row>
                <v-col class="headline1 font16 bold">สิทธิประโยชน์</v-col>
              </v-row>
              <v-row>
                <v-col>สาขาของเรา</v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MenuItem from '../MenuItem'
export default {
  components: {
    'menu-item': MenuItem
  },
  data () {
    return {
      level: null,
      tab: null,
      isShow: false,
      shop: [],
      shopname: [],
      items2: [],
      // member: null,
      profile: null,
      shopId: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    // this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()
    await this.getOnlyShop()
    await this.getBranch()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    goBack () {
      window.history.back()
    },
    async getOnlyShop () {
      const result = await this.callBeTaskAPI(
        'get',
        `/only_shop/get?shopId=${this.shopId}`
      )
      if (result) {
        if (Array.isArray(result)) {
          this.shopname = result[0].name
          this.shop = result
        }
      }
    },
    async getBranch () {
      const result = await this.callBeTaskAPI(
        'get',
        `/master_branch/get?shopId=${this.shopId}`
      )
      if (result) {
        if (Array.isArray(result)) {
          this.items2 = result
        }
      }
    },
    toggle () {
      this.isShow = !this.isShow
    }
  }
}
</script>
<style scoped>
.v-application .primary--text {
  color: red;
}
p {
  margin-bottom: 0;
  margin: auto;
  color: black;
}
a.v-tab {
  text-decoration: none;
}
.slide-down-enter-active,
.slide-down-leave-active {
  transition: max-height 0.5s;
}

.slide-down-enter-to,
.slide-down-leave {
  transform-origin: top ;
  animation-name: menu1;
  animation-duration: 200ms;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
  transition: max-height 2s;
}

.slide-down-enter,
.slide-down-leave-to {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.5s;

}
.test{
  transform-origin: bottom ;
    animation-name: menu2;

  overflow: hidden;
  max-height: 0;
  transition: max-height 0.5s;
    animation-timing-function: ease-in-out;

}
.animation{
  transform-origin: top ;
  animation-name: menu1;
  animation-duration: 200ms;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
}
 @keyframes menu1 {
  0%   { opacity: 0; transform: rotateX(-50deg)}
  100% { opacity: 1; transform: rotateX(0)}
}
</style>



// WEBPACK FOOTER //
// src/components/Account/Mybranch.vue